// 项目统计API
import request from '@/utils/request'
/**
 * 根据pid查询项目的保养天数
 * @param pid
 * @returns {*}
 */
export function maintain(pid) {
    return request({
        url: '/census/project/'+pid+'/maintain',
        method: 'get'
    })
}
/**
 * 根据pid清除保养周期
 * @param pid
 * @returns {*}
 */
export function clearCensus(pid) {
    return request({
        url: '/census/project/clear/'+pid,
        method: 'get'
    })
}
/**
 * 根据pid查询项目统计结果
 * @param pid
 * @returns {*}
 */
export function getCensus(pid) {
    return request({
        url: '/census/project/'+pid,
        method: 'get'
    })
}
